import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  background-color: #e1e7ee;
`;

export const Container = styled.div`
  width: 1200px;
  margin: 0 auto;
`;

export const LeftWrap = styled.div`
  width: 285px;
  float: left;
`;

export const RightWrap = styled.div`
  width: 895px;
  float: right;
`;

export const SeoCard = styled.div`
  width: ${props => (props.isDomesticRoundTrip ? '445px' : 'auto')};
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.13);
  background-color: #ffffff;
  margin-top: 1rem;
  .blueGrey {
    color: #647a97;
  }
  .curPointFlt {
    cursor: pointer;
  }
  a {
    color: #166bd3;
    cursor: pointer;
    outline: none;
    text-decoration: none;
  }
  .whiteBg {
    background-color: #ffffff;
  }
  .lh1 {
    line-height: 1;
  }
  .padT3 {
    padding-top: 3px;
  }
  .strike {
    text-decoration: line-through;
  }
  .padTB3 {
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
  }
  .padL20 {
    padding-left: 2rem;
  }
  .padR20 {
    padding-right: 2rem;
  }
  .padT20 {
    padding-top: 2rem;
  }
  .padB20 {
    padding-bottom: 2rem;
  }
  .padR10 {
    padding-right: 1rem;
  }
  .font16 {
    font-size: 1.6rem;
  }
  .font18 {
    font-size: 1.8rem;
  }
  .font20 {
    font-size: 2rem;
  }
  .font24 {
    font-size: 2.4rem;
  }
  .vh {
    visibility: hidden;
  }
  .padR15 {
    padding-right: 1.5rem;
  }
  .padTB15 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .padTB5 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  *:after,
  *:before {
    box-sizing: border-box;
  }
  .borderTop {
    border-top: 1px solid #e6e6e6;
  }
  .hpyBlueLt {
    color: #2276e3;
  }
`;

export const CardLeft = styled.div`
  width: 62%;
`;
export const CardRight = styled.div`
  width: 38%;
  // margin-top: 16px;
`;
export const CardWrap = styled.div`
  padding: 0 ${props => props.theme.spacing.custom(20)} 0;
`;

export const CardFooter = styled.div`
  padding: 1rem ${props => props.theme.spacing.custom(20)}
    ${props => props.theme.spacing.custom(10)};
  color: ${props => props.theme.colors.ash.base};
`;

export const PriceWrap = styled.div`
  width: 60%;
`;

export const BookWrap = styled.div`
  width: 33%;
  margin-left: 40px;
`;

export const Dep = styled.div`
  width: 27%;
`;
export const Dur = styled(Dep)`
  width: 33%;
`;
export const Space = styled.div`
  width: 11%;
`;
export const Arr = styled(Dep)``;

export const Time = styled.span`
  font-size: ${props => props.theme.font.custom(18)};
`;
export const DurTime = styled.span`
  font-size: ${props => props.theme.font.custom(16)};
`;

export const Price = styled.div`
  font-size: ${props => props.theme.font.custom(18)};
  position: relative;
`;
export const Emi = styled.div``;
export const Lcity = styled.span`
  padding: 0 ${props => props.theme.spacing.custom(10)};
`;

export const BookBtWrap = styled.div`
  /* padding-top: ${props => props.theme.spacing.custom(30)}; */
  /* padding-bottom: ${props => props.theme.spacing.custom(20)}; */
`;

export const BookButton = styled.button`
  border-radius: 0.5rem;
  outline: none;
  color: #ffffff;
  text-transform: ${props => (props.route ? 'capitalize' : 'uppercase')};
  border: none;
  width: auto;
  padding: 7px 10px;
  cursor: pointer;
  a {
    text-decoration: none;
    color: #ffffff;
  }
  position: relative;
  ${props => {
    if (Array.isArray(props.bgColor) && props.bgColor.length) {
      return css`
        background: ${props.bgColor.length === 1
          ? props.bgColor[0]
          : `linear-gradient(90deg, ${props.bgColor.join(',')})`};
      `;
    }
    return css`
      background-color: #ff6d38;
    `;
  }}
`;

export const CarrierLogo = styled.img`
  max-width: 100%;
  max-height: 25px;
  padding-right: ${props => props.theme.spacing.small};
`;

export const Spinner = styled.div`
  font-size: 6px;
  text-indent: -9999em;
  width: 4em;
  height: 4em;
  border-radius: 50%;
  background: #ffffff;
  background: linear-gradient(to right, #ffffff 10%, rgba(255, 255, 255, 0) 42%);
  position: relative;
  animation: load3 1.4s infinite linear;

  transform: translateZ(0);
  overflow: hidden;
  &::before {
    width: 50%;
    height: 50%;
    background: #ffffff;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  &::after {
    background: #ff6d38;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  @keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

export const ResultCard = styled.div`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.13);
  border-radius: 0.5rem;
  background: #fff;
  // min-height: 110px;
  &.sticky {
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 19.5rem;
    z-index: 6;
  }
  margin-top: 5px;
  .hpyBlueLt {
    color: #2276e3;
  }
`;

export const AlternateCard = styled(ResultCard)`
  background-color: #485785 !important;
  padding: 0.5rem;
  .curPointFlt {
    cursor: pointer;
  }
  .blueGrey {
    color: #647a97;
  }
  .curPointFlt {
    cursor: pointer;
  }
  a {
    color: #166bd3;
    cursor: pointer;
    outline: none;
    text-decoration: none;
  }
  .font10 {
    font-size: 1rem;
  }
  .whiteBg {
    background-color: #ffffff;
  }
  .lh1 {
    line-height: 1;
  }
  .padT3 {
    padding-top: 3px;
  }
  .strike {
    text-decoration: line-through;
  }
  .padTB3 {
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
  }
  .padL20 {
    padding-left: 2rem;
  }
  .padR20 {
    padding-right: 2rem;
  }
  .padT20 {
    padding-top: 2rem;
  }
  .padB20 {
    padding-bottom: 2rem;
  }
  .padR10 {
    padding-right: 1rem;
  }
  .font16 {
    font-size: 1.6rem;
  }
  .font18 {
    font-size: 1.8rem;
  }
  .font20 {
    font-size: 2rem;
  }
  .font24 {
    font-size: 2.4rem;
  }
  .vh {
    visibility: hidden;
  }
  .padR15 {
    padding-right: 1.5rem;
  }
  .padTB15 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  *:after,
  *:before {
    box-sizing: border-box;
  }
  .borderTop {
    border-top: 1px solid #e6e6e6;
  }
`;

export const ResultWrap = styled.div`
  padding: 1rem 2rem 0;
`;

export const Col9 = styled.div`
  width: 75%;
`;

export const Col8 = styled.div`
  width: 66.66666667%;
  .brdrBtmDash {
    border-bottom: 1px dashed #e6e6e6;
  }
`;

export const Col4 = styled.div`
  width: 33.33333333%;
`;

export const Col3 = styled.div`
  width: 25%;
`;

export const Col7 = styled.div`
  width: 58.33333333%;
`;

export const Col5 = styled.div`
  width: 41.66666667%;
`;

export const Width11 = styled.div`
  width: 11%;
`;
export const Width29 = styled.div`
  width: 29%;
`;

export const Fltbook = styled.input.attrs({
  type: 'button'
})`
  border-radius: 5px;
  padding: 7px 0;
  ${props => {
    if (Array.isArray(props.bgColor) && props.bgColor.length) {
      return css`
        background: ${props.bgColor.length === 1
          ? props.bgColor[0]
          : `linear-gradient(90deg, ${props.bgColor.join(',')})`};
      `;
    }
    return css`
      background-color: #f37638;
    `;
  }}
  border: solid 1px ${props =>
    props.brColor
      ? props.brColor.length === 1
        ? props.brColor[0]
        : `linear-gradient(90deg, ${props.brColor.join(',')})`
      : '#f37638'};
  font-size: 12px;
  -webkit-appearance: none;
  color: #fff;
  text-align: center;
  cursor: pointer;
  &.widthF105 {
    width: 105px;
  }
  &.fltbookOutln {
    background: transparent;
    border: solid 1px #f37638;
    color: #eb6125;
    border-radius: 5px;
  }
`;
export const BrdrBtmDash = styled.div`
  border-bottom: 1px dashed #e6e6e6;
`;
export const DetailsLink = styled.div`
  padding: 0 2rem;
  &.detailLinkRnd {
    padding: 0 1rem;
  }
`;

export const FlightDetailsWrap = styled.div`
  &.heightAnim {
    overflow-y: hidden;
    max-height: 1200px;
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    transition: max-height 0.5s ease-out;
  }
  &.closed {
    max-height: 0;
    transition: max-height 0.2s ease-out;
  }
`;

export const FltDetailCnt = styled.div`
  padding: 2rem;
`;
export const FltHpyDtlMenu = styled.div`
  background-color: #eff3f8;
  border-radius: 30px;
  .switchAct {
    background-color: #2276e3;
    border-radius: 30px;
    color: #fff;
  }
  span {
    padding: 8px 15px;
  }
`;
export const FltDetailContWrp = styled.div`
  margin-top: 2rem;
`;
export const FltDetailCont = styled.div`
  padding: 2rem 0;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  .col-sm-10 {
    width: 83.33333333%;
  }
  .widMd13 {
    width: 13%;
  }
  .widMd31 {
    width: 31%;
  }
  .col-md-3 {
    width: 25%;
  }
  .backgroundLn {
    position: relative;
    z-index: 1;
  }
  .backgroundLn:before {
    border-top: 1px dashed #dfdfdf;
    content: '';
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    width: 98%;
    z-index: -1;
  }
  .oval-2 {
    width: 7px;
    height: 7px;
    background-color: #2276e3;
    border-radius: 50%;
    margin-top: 1px;
  }
  .padLR20 {
    padding-left: 20px;
    padding-right: 20px;
  }
  .widMd31 {
    width: 31%;
  }
  .lh1-2 {
    line-height: 1.2;
  }
  .tri-right,
  .tri-left {
    position: relative;
  }
  .tri-left:before,
  .tri-left:after,
  .tri-right:before,
  .tri-right:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-color: transparent;
    top: -10px;
  }
  .tri-right:before {
    border-left: 10px solid #e6e6e6;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    left: 0;
  }
  .tri-right:after {
    border-left: 10px solid #ffffff;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 8px solid transparent;
    left: -2px;
  }
  .tri-left:before {
    border-right: 10px solid #e6e6e6;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    right: -1px;
  }
  .tri-left:after {
    width: 0;
    height: 0;
    border-right: 10px solid #ffffff;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-left: 8px solid transparent;
    right: -3px;
  }
  .blueGrey {
    color: #647a97;
  }
  .paleGreyBg {
    background-color: #eff3f8;
  }
  .marginTB20 {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .padTB3 {
    padding-top: 3px;
    padding-bottom: 3px;
  }
  .padLR15 {
    padding-left: 15px;
    padding-right: 15px;
  }
  .brdrRd10 {
    border-radius: 10px;
  }
  .padL10 {
    padding-left: 1rem;
  }
`;
export const AlternateText = styled.span`
  background-image: linear-gradient(266deg, #ed4545, #ee5858);
  z-index: 0;
  border-radius: 5px 0 20px 0;
  color: #fff;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 15px;
  padding-right: 15px;
  position: relative;
`;

export const AlternateSaveText = styled.span`
  background-image: linear-gradient(257deg, #00c57e, #18a160);
  position: relative;
  z-index: 0;
  border-radius: 0 5px 0 15px;
  color: #fff;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 5px;
  padding-right: 5px;
`;

export const FareFamilyHeaderWrapper = styled.div`
  float: right;
  height: 0px;
`;

export const FareFamilyHeader = styled.span`
  font-style: normal;
  float: right;
  background-image: linear-gradient(96deg, #1149f3, #00c3ff);
  position: relative;
  z-index: 0;
  border-radius: 0 5px 0 20px;
  font-size: 11px;
  color: #fff;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-left: 15px;
  padding-right: 15px;
`;

export const MultiBanner = styled.div`
  padding-top: 5px;
  margin-left: ${props => (props.domRT ? '-10px' : '-20px')};
  align-items: center;
  display: flex;
`;

export const MultiBannerTag = styled.span`
  font-size: 11px;
  font-weight: 500;
  font-style: normal;
  border-radius: 50px;
  background-image: linear-gradient(261deg, #a9b0b0, #34393a);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  color: #fff;
  line-height: 1;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
`;

export const FltTag = styled.span`
  float: left;
  height: 18px;
  line-height: 18px;
  position: relative;
  font-size: 11px;
  padding: 0 10px 0 12px;
  background: #a61124;
  color: #fff;
  text-decoration: none;
  :before {
    content: '';
    float: left;
    position: absolute;
    top: 0;
    left: -11px;
    width: 0;
    height: 0;
    border-color: transparent #a61124 transparent transparent;
    border-style: solid;
    border-width: 9px 11px 9px 0;
  }
  :after {
    content: '.';
    position: absolute;
    top: 7px;
    left: 0;
    float: left;
    width: 5px;
    height: 5px;
    border-radius: 2px;
    -webkit-border-radius: 2px;
    -moz-border-radius: 2px;
    background: #fff;
  }
`;

export const OfferText = styled.span`
  padding-left: 5px;
  color: ${props => props.color || '#18a160'};
`;

export const DiscountWrap = styled.div`
  background-color: #fffae9;
  padding-right: 5px;
  border-radius: 10px;
  color: #846418;
  align-items: center;
  display: flex;
  margin-left: 80px;
`;

export const FlysmartText = styled.p`
  margin-top: 4px;
  position: relative;
  top: 3px;
`;

export const LockButtonPlaceholder = styled.p`
  height: 32px;
  margin-bottom: 5px;
`;

export const ViewFaresLeft = styled.div`
  width: 580px;
  & .upgardeFFtag:before {
    width: 0;
    height: 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 8px solid #ffc24a;
    content: '';
    position: absolute;
    left: -6px;
    top: 7px;
  }
  & .upgardeFFtag {
    background: #ffc24a;
    border-radius: 4px;
    padding: 6px 12px;
    position: relative;
    margin-left: 10px;
  }
`;

export const ButtonOuter = styled.div`
  margin-left: 37px;
`;

export const SlashedFare = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
`;

export const PromoTag = styled.div`
  .dateChange,
  .eticketTime,
  .farelock,
  .cheapest,
  .extraSeat {
    color: #18a160;
    position: relative;
    z-index: 0;
    border-radius: 0 5px 0 20px;
    padding: 3px 12px 3px 10px;
    background-image: linear-gradient(257deg, #e8f5ef, #e8f5ef);
  }
  .dateChange:after {
    background-image: linear-gradient(257deg, #e8f5ef, #e8f5ef);
  }
  .eticketTime,
  .eticketTime:after {
    background-image: linear-gradient(266deg, #8734f3 100%, #3b41ff 0%);
    color: #ffffff;
  }

  .farelock {
    background: linear-gradient(
      to right,
      #974815 0%,
      #ab5a24 11%,
      #f2ac72 17%,
      #c87338 23%,
      #934115 100%
    );
    color: #ffffff;
  }

  .dateChange:after,
  .eticketTime:after,
  .farelock:after,
  .cheapest:after,
  .extraSeat:after {
    content: ' ';
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
    transform-origin: bottom left;
    transform: skew(30deg, 0deg);
    border-radius: 0 0 0 6px;
  }
  .farelock:after {
    background-color: #ae5d26;
    width: 10%;
  }
  .cheapest,
  .cheapest:after {
    background-image: linear-gradient(134.97deg, #1b9564 0%, #39d546 100%);
    color: #ffffff;
  }
  .extraSeat,
  .extraSeat:after {
    color: #ffffff;
    background-image: linear-gradient(257deg, #2276e3 100%, #2276e3 0%);
  }
`;

export const FlySmart = styled.div`
  color: #18a160;
  position: relative;
  &:hover .dailyStealDeal {
    display: block;
  }
  &.showOnce .dailyStealDeal {
    display: block;
  }
  & .dailyStealDeal {
    background: #262626;
    padding: 13px 22px;
    border-radius: 6px;
    position: absolute;
    right: 20px;
    width: 182px;
    color: #fff;
    display: none;
    :before {
      content: '';
      width: 0;
      height: 0;
      border-top: 7px solid transparent;
      border-bottom: 7px solid transparent;
      border-left: 7px solid #262626;
      position: absolute;
      right: -7px;
      top: 25px;
    }
  }
`;

export const LayoverOfferWrap = styled.div`
  width: 84%;
`;

export const SeatsLeft = styled.div`
  color: #ff3a5c;
  text-align: right;
`;

export const ExtraSeatIco = styled.span`
  width: 8px;
  height: 8px;
  margin-right: 3px;
  border-radius: 2px;
  background-color: #ffffff;
`;

export const RouteWrap = styled.div`
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #efefef;
  &:first-child {
    margin-top: 0;
    padding-top: 0;
    border-top-width: 0;
  }
`;

export const Persuasion = styled.div`
  padding: 3px 6px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  color: #ffffff;
  display: inline-block;
  ${props => {
    if (Array.isArray(props.bgColor) && props.bgColor.length) {
      return css`
        background: ${props.bgColor.length === 1
          ? props.bgColor[0]
          : `linear-gradient(90deg, ${props.bgColor.join(',')})`};
      `;
    }
  }}
`;

export const HandBaggage = styled.div`
  ${props =>
    Array.isArray(props.bgColor) && props.bgColor.length === 1
      ? css`
          background: ${props.bgColor[0]};
        `
      : Array.isArray(props.bgColor) &&
        props.bgColor.length > 1 &&
        css`
          background-image: linear-gradient(90deg, ${props.bgColor.join(',')});
        `}
  border-radius: 4px;
  padding: 2px 4px 4px;
  color: #2276e3;
`;

export const BorderSpan = styled.span`
  color: #e4e4e4;
`;

export const SpecialTag = styled.div`
  background: ${props => props.bgColor || '#fce9fc'};
  color: ${props => props.color || '#861388'};
  padding: 3px 16px 3px 10px;
  border-radius: 4px 0 0 4px;
`;
